import React, { FC } from 'react';
import { Checkbox, Form } from 'antd';

// Shared UI Library Components
import { CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './rating-filter.scss';

type TRatingFilterProps = {};

export const RatingFilter: FC<TRatingFilterProps> = (
  {}: TRatingFilterProps
) => {

  const options = new Array(5).fill(null).map((_, idx) => ({
    value: 5 - idx,
    label:
      Array(Number(5 - idx))
        .fill(null)
        .map((_, childIdx) => (
          <CustomIcon className="rating-fill-item" key={ childIdx } name={ EIconName.StarFill }/>
        ))
  }));

  return (
    <div className="rating-filter">
      <Form.Item name={ 'review_rating' }>
        <Checkbox.Group options={ options }/>
      </Form.Item>
    </div>
  );
}
